import React, { useRef, useEffect, useState } from "react";
import "@toast-ui/editor/dist/toastui-editor.css";
import { Editor } from "@toast-ui/react-editor";
import { Link, useNavigate, useParams } from "react-router-dom";
import SubHeader from "../components/subHeader3";
import SubHeader2 from "../components/subHeader4";

import "./css/write.css";
import axios from "axios";
import moment from "moment";

export default function TextEditor() {
  // Editor DOM
  const editorRef = useRef();
  const navigate = useNavigate();

  const [value, setValue] = useState("");
  const [subject, setSubject] = useState("");
  const [fileArray, setArray] = useState([]);
  const [imgLink, setImgLink] = useState("");
  const [boardName, setBoardName] = useState("");
  const { board } = useParams();
  const [header, setHeader] = useState("");


  const preventClose = (e: BeforeUnloadEvent) => {
    e.preventDefault();
    e.returnValue = ""; //Chrome에서 동작하도록; deprecated
  };
  
  useEffect(() => {
    setBoardName(board);
    if (board === "pr") {
      setHeader("홍보자료");
    } else if (board === "news") {
      setHeader("활동사항");
    } else {
      setHeader("인재채용");
    }

    (() => {
      window.addEventListener("beforeunload", preventClose);
    })();
   
    return () => {
      window.removeEventListener("beforeunload", preventClose);
    };
  }, []);
 
   
 
  const subjectChange = (event) => {
    setSubject(event.target.value);
  };
  let files = [];

  //게시글 등록 버튼 핸들러
  const handleRegisterButton = () => {
    console.log(editorRef.current?.getInstance().getHTML());
    if (subject === "") {
      alert("제목을 입력해주세요.");
      return false;
    } else if (
      editorRef.current?.getInstance().getHTML() ===
      '<p><br className="ProseMirror-trailingBreak"></p>'
    ) {
      alert("내용을 입력해주세요.");
      return false;
    }
    var arrayLength = fileArray.length;
    var extractStr = editorRef.current?.getInstance().getMarkdown();
    for (var i = 0; i < arrayLength; i++) {
      let result = extractStr.match(fileArray[i]);
      console.log("result: " + result);
      if (result == null) {
        var filename = fileArray[i].substring(
          fileArray[i].lastIndexOf("/") + 1
        );

        axios
          .delete("https://thegmmedical.com:5002/api/deletepic", {
            data: {
              // 서버에서 req.body.{} 로 확인할 수 있다.
              file_name: filename,
              board_name: boardName,
            },
          })
          .then(() => this.setState({ status: "Delete successful" }));
      }
      //Do something
    }

    const date_time = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
    const board = {
      content: editorRef.current?.getInstance().getHTML(),
      content_txt: editorRef.current
        ?.getInstance()
        .getHTML()
        .replace(/<\/?[^>]+(>|$)/g, ""), // 입력창에 입력한 내용을 HTML 태그 형태로 취득
      date_time: date_time,
      subject: subject,
      img_link: imgLink,
      board_name: boardName,
    };
    const fetch = async () => {
      await axios
        .post("https://thegmmedical.com:5002/api/boardinsert", board, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8",
          },
        })
        .then(({ data }) => {
          console.log("...." + data);
          navigate("/" + boardName);
        });
    };
    fetch();
  };

  return (
    <div className="">
      {header === "인재채용" && <SubHeader2 />}
      {header !== "인재채용" && <SubHeader />}
      <h1 className="headerText">{header}</h1>

      <div className="write_wrapper">
        <form id="write-form" noValidate>
          <div className="formRow">
            <div className="col col_title">
              <input
                type="text"
                name="name"
                className="formInput"
                placeholder="제목을 입력하세요."
                onChange={subjectChange}
                value={subject}
              ></input>
            </div>
          </div>
          <div className="formRow">
            <div className="">
              <Editor
                ref={editorRef}
                initialValue=" "
                previewStyle="vertical"
                height="300px"
                onChange={setValue}
                initialEditType="wysiwyg"
                toolbarItems={[
                  // 툴바 옵션 설정
                  ["heading", "bold", "italic", "strike"],
                  ["hr", "quote"],
                  ["ul", "ol", "task", "indent", "outdent"],
                  ["table", "image", "link"],
                  ["code", "codeblock"],
                ]}
                // hooks 에서 addImageBlobHook 를 주물러 주면 된다.
                hooks={{
                  addImageBlobHook: async (blob, callback) => {
                    console.log(blob.size);
                    if (blob.size > 5000000) {
                      alert(
                        "업로드에 실패했습니다. 이미지당 5MB까지 업로드할 수 있습니다."
                      );
                      return;
                    }
                    
                    // File {name: '카레유.png', ... }
                    const formData = new FormData();
                    formData.append("img", blob);
                    
                    // 1. 첨부된 이미지 파일을 서버로 전송후, 이미지 경로 url을 받아온다.
                    // const imgUrl = await .... 서버 전송 / 경로 수신 코드 ...
                    await axios.post(
                      "https://thegmmedical.com:5002/api/img?board=" + board,
                      formData
                    ).then(( res ) => {
                      console.log(res);
                      console.log(
                        "성공 시, 백엔드가 보내주는 데이터",
                        res.data.url
                      );
  
                      const IMG_URL = res.data.url;
                      setImgLink(IMG_URL);
                      // 2. 첨부된 이미지를 화면에 표시(경로는 임의로 넣었다.)
                      callback(IMG_URL, "test");
                      //alert(IMG_URL);
                      files.push(IMG_URL);
                      setArray(files);
                      //setArray((fileArray) => [...fileArray, IMG_URL]);
                      //alert("fileArray: ", files);
                      console.log(files);
                      var arrayLength = files.length;
                      //alert(arrayLength);
                      //alert("end");
                    
                    });
                    
                    
                    
                  },
                }}
              ></Editor>
            </div>
          </div>
          {/*<div style={{padding:"20px 30px", border:"2px solid #000", width:"150px", textAlign:"center", display:"inline-block", cursor:"pointer"}} onClick={deletePicButton}>이미지 삭제 TEST 버튼</div>*/}
        </form>
        <div
          style={{
            marginTop: "40px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Link to={"/" + boardName} id="toList">
            {" "}
            <div className="btn_list">목록으로</div>
          </Link>
          <div className="btn_write" onClick={handleRegisterButton}>
            글 작성
          </div>
        </div>
      </div>
    </div>
  );
}
